import React from 'react'
import { connect } from 'react-redux';

import {
  getLoanApplication,
} from '../../../reducers'

import {loanApplicationFetchStart, loanApplicationUserGobackStart, updateReviewStart} from '../../../actions';
import Documentation from './Documentation'
import Incomes from './Incomes'
import Expenses from './Expenses'
import Commitments from './Commitment/Commitments'
import Asset from './Asset'
import LoanDetail from './LoanDetail'
import PersonalDetail from './PersonalDetail'
import Employment from './Employment'
import Declaration from './Declaration'
import LoanSummaryReviewText from './LoanSummaryReviewText'

class Review extends React.Component {
  state = {
    continueButtonEnabled: true
  }

  componentDidMount() {
    window.scrollTo({top: 0})

    this.props.loanApplicationFetchStart({id: gon.loan_application.id})
  }

  onContinueClick = () => {
    this.setState({ continueButtonEnabled: false })

    this.props.updateReviewStart({
      termsAndConditions: true
    })
  }

  loanSummaryReviewed = () => {
    const { role, loanSummaryReviewed } = this.props
    return role !== 'primary' && loanSummaryReviewed
  }

  renderSubmit = () => {
    const { role, conditional } = this.props
    const {
      continueButtonEnabled
    } = this.state

    if (role === 'primary' || this.loanSummaryReviewed() || (conditional && role === 'secondary')) {
      return (
        <button className='btn btn-lg btn-green btn-block' onClick={this.onContinueClick} disabled={ !continueButtonEnabled }>
          Submit loan
          <span className='d-none d-sm-inline'> application</span>
        </button>
      )
    } else {
      return (
        <button className='btn btn-lg btn-green btn-block' disabled>
          Submit loan
          <span className='d-none d-sm-inline'> application</span>
        </button>
      )
    }
  }

  render() {
    const {
      review,
      onGoToClick,
      needsLoanSetup,
    } = this.props

    const { commitments } = review

    return(
      <div>
        <h3>Review your application</h3>
        <p className='grey big mb-4'>Please review all details of your application before submitting.</p>

        <Documentation />
        <Incomes onGoToClick={ onGoToClick } />
        <Expenses onGoToClick={ onGoToClick } />

        <Commitments onGoToClick={ onGoToClick } />

        { this.props.purpose === 'purchase' &&
          <Asset onGoToClick={ onGoToClick } />
        }

        {
          (false) && (
            <LoanDetail onGoToClick={ onGoToClick } />
          )
        }
        <PersonalDetail onGoToClick={ onGoToClick } />
        <Employment onGoToClick={ onGoToClick } />
        <Declaration onGoToClick={ onGoToClick } />
        <LoanSummaryReviewText role={this.props.role}
                               loanSummaryReviewed={this.props.loanSummaryReviewed}
                               conditional={ this.props.conditional }
        />
        {this.renderSubmit()}
      </div>
    )
  }
}

const mapStateToProps = (state) => ({
  canViewLoanSummary: state.loanApplicationUser.primary.canViewLoanSummary,
  role: state.loanApplicationUser.primary.role,
  loanSummaryReviewed: state.loanApplicationUser.primary.loanSummaryReviewed,
  review: state.review,
  conditional: state.loanApplication.conditional,
  purpose: state.loanApplication.purpose,
  needsLoanSetup: getLoanApplication(state).needsLoanSetup,
})

export default connect(mapStateToProps, {
  updateReviewStart,
  loanApplicationUserGobackStart,
  loanApplicationFetchStart,
})(Review)
